module.exports = __webpack_public_path__ + "media/ab-homepage/snail-b90ceed0.png";